import type { ReactNode } from "react";

/** 加载时占位，就绪后换成真实内容；避免调用处写三元。 */
export function LoadingSkeleton({
  loading,
  skeleton,
  children,
}: {
  loading: boolean;
  skeleton: ReactNode;
  children: ReactNode;
}) {
  return <>{loading ? skeleton : children}</>;
}
